import { Design as UnlayerDesign } from 'views/Template/components';
import { default as useUnlayerTemplate } from 'views/Template/useTemplate';

const IFrameUnlayerEditor = props => {
    const unlayerTemplate = useUnlayerTemplate();

    return (
        <UnlayerDesign template={unlayerTemplate} showNav={true} isIFrame={true} />
    )
}

export default IFrameUnlayerEditor;